import React from "react";
import {FormattedMessage, injectIntl} from "gatsby-plugin-react-intl";
import {Button, Col, Form, FormControl, Modal, Row, Spinner} from "react-bootstrap";
import {createAccount, checkPassword, listCountries} from "../../request";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class SignupForm extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            selectedCurrency: "eur",
            selectedPlan: props.plan,
            company: "",
            hasCompanyError: false,
            firstName: "",
            hasFirstNameError: false,
            lastName: "",
            hasLastNameError: false,
            countries: [],
            country: "NL",
            hasCountryError: false,
            phone: "",
            email: "",
            hasEmailError: false,
            password: "",
            hasPasswordError: false,
            confirmPassword: "",
            hasConfirmPasswordError: false,
            hasPasswordMatchError: false,
            passwordCompliance: false,
            passwordPolicyError: null,
            updates: false,
            newsletter: false,
            termsAgreed: false,
            hasTermsAgreedError: false,
            isProcessing: false,
            showModal: false,
            fieldsError: false,
            serverError: false,
            finished: false
        };

    }

    componentDidMount(){

        if (typeof window !== 'undefined' && !localStorage.getItem("notificareSelectedCurrency")) {
            localStorage.setItem("notificareSelectedCurrency", "eur");
        }

        this.setState({
            selectedCurrency: localStorage.getItem("notificareSelectedCurrency").toUpperCase()
        });

        listCountries().then((results) => {
            this.setState({
                countries: results.data.countries
            });
        });
    }

    handleInputChange = (e) => {
        if (e && e.target && e.target.name) {
            this.setState({
                [e.target.name]: e.target.value
            });
        }

        this.setState({
            hasCompanyError: false,
            hasFirstNameError: false,
            hasLastNameError: false,
            hasCountryError: false,
            hasEmailError: false,
            hasPasswordError: false,
            hasConfirmPasswordError: false,
            hasPasswordMatchError: false,
            hasTermsAgreedError: false
        });
    }

    checkPasswordPolicy = (e) => {
        if (e && e.target && e.target.value) {
            let names = [];

            if (this.state.firstName) {
                names.push(this.state.firstName);
            }

            if (this.state.lastName) {
                names.push(this.state.lastName);
            }

            if (this.state.company) {
                names.push(this.state.company);
            }

            if (this.state.email) {
                let address = this.state.email.split("@");
                names.push(address[0]);
            }

            checkPassword({
                password: e.target.value,
                names: names
            }).then((result) => {
                this.setState({
                   passwordCompliance: true,
                   passwordPolicyError: null
                });
            }).catch((e) => {
                this.setState({
                    passwordCompliance: false,
                    passwordPolicyError: (e && e.response && e.response.data && e.response.data.error) ? e.response.data.error : null
                });
            });
        }
    }



    handleSubmit = (e) => {
        e.preventDefault();


        this.setState({
            isProcessing: true,
            showModal: false,
            hasCompanyError: false,
            hasFirstNameError: false,
            hasLastNameError: false,
            hasCountryError: false,
            hasEmailError: false,
            hasPasswordError: false,
            hasConfirmPasswordError: false,
            hasPasswordMatchError: false,
            hasTermsAgreedError: false,
            fieldsError: false,
            finished: false,
            serverError: false
        });

        if (!this.state.company) {
            this.setState({
                showModal: true,
                fieldsError: true,
                isProcessing: false,
                hasCompanyError: true
            });
        } else if (!this.state.firstName) {
            this.setState({
                showModal: true,
                fieldsError: true,
                isProcessing: false,
                hasFirstNameError: true
            });
        } else if (!this.state.lastName) {
            this.setState({
                showModal: true,
                fieldsError: true,
                isProcessing: false,
                hasLastNameError: true
            });
        } else if (!this.state.country) {
            this.setState({
                showModal: true,
                fieldsError: true,
                isProcessing: false,
                hasCountryError: true
            });
        } else if (!this.state.email) {
            this.setState({
                showModal: true,
                fieldsError: true,
                isProcessing: false,
                hasEmailError: true
            });
        } else if (!this.validateEmail(this.state.email)) {
            this.setState({
                showModal: true,
                fieldsError: true,
                isProcessing: false,
                hasEmailError: true
            });
        } else if (!this.state.password) {
            this.setState({
                showModal: true,
                fieldsError: true,
                isProcessing: false,
                hasPasswordError: true
            });
        } else if (!this.state.passwordCompliance) {
            this.setState({
                showModal: true,
                fieldsError: true,
                isProcessing: false
            });
        } else if (!this.state.confirmPassword) {
            this.setState({
                showModal: true,
                fieldsError: true,
                isProcessing: false,
                hasConfirmPasswordError: true
            });
        } else if (this.state.password !== this.state.confirmPassword) {
            this.setState({
                showModal: true,
                fieldsError: true,
                isProcessing: false,
                hasPasswordMatchError: true
            });
        } else if (!this.state.termsAgreed) {
            this.setState({
                showModal: true,
                fieldsError: true,
                isProcessing: false,
                hasTermsAgreedError: true
            });
        } else {
            createAccount({
                name: this.state.firstName + ' ' + this.state.lastName,
                email: this.state.email,
                password: this.state.password,
                plan: this.state.selectedPlan,
                terms_agreed: true,
                billing_info: {
                    company: this.state.company,
                    first_name: this.state.firstName,
                    last_name: this.state.lastName,
                    country: this.state.country,
                    phone: this.state.phone
                },
                preferences:{
                    currency: this.state.selectedCurrency,
                    news_letter: this.state.newsletter,
                    updates: this.state.updates
                }
            }).then(() => {
                this.setState({
                    isProcessing: false,
                    showModal: true,
                    finished: true,
                    company: "",
                    firstName: "",
                    lastName: "",
                    country: "NL",
                    phone: "",
                    email: "",
                    password: "",
                    confirmPassword: "",
                    updates: false,
                    newsletter: false,
                    termsAgreed: false
                });
                window.dataLayer.push('event', 'conversion', {'send_to': 'AW-970402719/RXNKCNfc0ZEYEJ_X3M4D'});
            }).catch(() => {
                this.setState({
                    isProcessing: false,
                    showModal: true,
                    serverError: true
                });
            });
        }

    }

    closeModal = () => {
        this.setState({
            showModal: false
        });
    }

    validateEmail = email => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    render() {
        return (
            <div className={`signup-form`}>
                <div className={`title`}>
                    <FormattedMessage id="components.signupForm.title" />
                </div>
                <Form className={`form-area`} onSubmit={this.handleSubmit}>
                    <Row>
                        <Col md={12}>
                            <div className={`form-field-group`}>
                                <Form.Label><FormattedMessage id="components.signupForm.company.label" /></Form.Label>
                                <FormControl type={`text`} value={this.state.company} name={`company`} className="form-field" onChange={this.handleInputChange} />
                                {this.state.hasCompanyError &&
                                <>
                                    <div className={`feedback-text error`}><FormattedMessage id="components.signupForm.company.error" /></div>
                                    <div className={`feedback-icon error`}><FontAwesomeIcon size={`lg`} icon="exclamation-circle" /></div>
                                </>
                                }
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <div className={`form-field-group`}>
                                <Form.Label><FormattedMessage id="components.signupForm.firstName.label" /></Form.Label>
                                <FormControl type={`text`} value={this.state.firstName} name={`firstName`} className="form-field" onChange={this.handleInputChange} />
                                {this.state.hasFirstNameError &&
                                <>
                                    <div className={`feedback-text error`}><FormattedMessage id="components.signupForm.firstName.error" /></div>
                                    <div className={`feedback-icon error`}><FontAwesomeIcon size={`lg`} icon="exclamation-circle" /></div>
                                </>
                                }
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className={`form-field-group`}>
                                <Form.Label><FormattedMessage id="components.signupForm.lastName.label" /></Form.Label>
                                <FormControl type={`text`} value={this.state.lastName} name={`lastName`} className="form-field" onChange={this.handleInputChange} />
                                {this.state.hasLastNameError &&
                                <>
                                    <div className={`feedback-text error`}><FormattedMessage id="components.signupForm.lastName.error" /></div>
                                    <div className={`feedback-icon error`}><FontAwesomeIcon size={`lg`} icon="exclamation-circle" /></div>
                                </>
                                }
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <div className={`form-field-group`}>
                                <Form.Label><FormattedMessage id="components.signupForm.country.label" /></Form.Label>
                                <div className={`select-container`}>
                                    <FormControl as={`select`} value={this.state.country}  name={`country`} className="form-field" onChange={this.handleInputChange}>
                                        {this.state.countries.map((country, i) => {
                                            return (
                                                <option key={i} value={country.alpha2_code}>{country.name}</option>
                                            )
                                        })}
                                    </FormControl>
                                </div>
                                {this.state.hasCountryError &&
                                <>
                                    <div className={`feedback-text error`}><FormattedMessage id="components.signupForm.country.error" /></div>
                                    <div className={`feedback-icon error`}><FontAwesomeIcon size={`lg`} icon="exclamation-circle" /></div>
                                </>
                                }
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className={`form-field-group`}>
                                <Form.Label><FormattedMessage id="components.signupForm.phone.label" /></Form.Label>
                                <FormControl type={`text`} value={this.state.phone} name={`phone`} className="form-field" onChange={this.handleInputChange} />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className={`form-field-group`}>
                                <Form.Label><FormattedMessage id="components.signupForm.email.label" /></Form.Label>
                                <FormControl type={`email`} value={this.state.email} name={`email`} className="form-field" onChange={this.handleInputChange} />
                                {this.state.hasEmailError &&
                                <>
                                    <div className={`feedback-text error`}><FormattedMessage id="components.signupForm.email.error" /></div>
                                    <div className={`feedback-icon error`}><FontAwesomeIcon size={`lg`} icon="exclamation-circle" /></div>
                                </>
                                }
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className={`form-field-group`}>
                                <Form.Label><FormattedMessage id="components.signupForm.password.label" /></Form.Label>
                                <FormControl type={`password`} value={this.state.password} name={`password`} className="form-field" onChange={this.handleInputChange} onKeyUp={this.checkPasswordPolicy} />
                                {this.state.hasPasswordError &&
                                <>
                                    <div className={`feedback-text error`}><FormattedMessage id="components.signupForm.password.errors.invalid" /></div>
                                    <div className={`feedback-icon error`}><FontAwesomeIcon size={`lg`} icon="exclamation-circle" /></div>
                                </>
                                }
                                {this.state.password && !this.state.passwordCompliance &&
                                <>
                                    <div className={`feedback-text error`}>{this.state.passwordPolicyError}</div>
                                    <div className={`feedback-icon error`}><FontAwesomeIcon size={`lg`} icon="exclamation-circle" /></div>
                                </>
                                }
                                {this.state.password && this.state.passwordCompliance &&
                                <div className={`feedback-icon success`}><FontAwesomeIcon size={`lg`} icon="check-circle" /></div>
                                }
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className={`form-field-group`}>
                                <Form.Label><FormattedMessage id="components.signupForm.confirmPassword.label" /></Form.Label>
                                <FormControl type={`password`} value={this.state.confirmPassword} name={`confirmPassword`} className="form-field" onChange={this.handleInputChange} />
                                {this.state.hasConfirmPasswordError &&
                                <>
                                    <div className={`feedback-text error`}><FormattedMessage id="components.signupForm.password.errors.match" /></div>
                                    <div className={`feedback-icon error`}><FontAwesomeIcon size={`lg`} icon="exclamation-circle" /></div>
                                </>
                                }
                                {this.state.hasPasswordMatchError &&
                                <>
                                    <div className={`feedback-text error`}><FormattedMessage id="components.signupForm.password.errors.match" /></div>
                                    <div className={`feedback-icon error`}><FontAwesomeIcon size={`lg`} icon="exclamation-circle" /></div>
                                </>
                                }
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12}>
                            <div className={`form-field-group mt-5`}>
                                <label className="checkbox-container">
                                    {this.props.intl.formatMessage({id: "components.signupForm.updates.label"})}
                                    <input type={`checkbox`} name={`updates`} checked={this.state.updates} onChange={(e) => {
                                        this.handleInputChange({
                                            target: {
                                                name: e.target.name,
                                                value: e.target.checked,
                                            }
                                        });
                                    }} />
                                    <span className={`checkmark`}></span>
                                </label>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12}>
                            <div className={`form-field-group mt-3`}>
                                <label className="checkbox-container">
                                    {this.props.intl.formatMessage({id: "components.signupForm.newsletter.label"})}
                                    <input type={`checkbox`} checked={this.state.newsletter} name={`newsletter`} onChange={(e) => {
                                        this.handleInputChange({
                                            target: {
                                                name: e.target.name,
                                                value: e.target.checked,
                                            }
                                        });
                                    }} />
                                    <span className={`checkmark`}></span>
                                </label>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12}>
                            <div className={`form-field-group mt-3`}>
                                <label className="checkbox-container">
                                    <span dangerouslySetInnerHTML={{__html: this.props.intl.formatMessage({id: "components.signupForm.termsAgreed.label"})}}></span>
                                    <input type={`checkbox`} checked={this.state.termsAgreed} name={`termsAgreed`} onChange={(e) => {
                                        this.handleInputChange({
                                            target: {
                                                name: e.target.name,
                                                value: e.target.checked,
                                            }
                                        });
                                    }} />
                                    <span className={`checkmark`}></span>
                                </label>
                                {this.state.hasTermsAgreedError &&
                                <div className={`feedback-text error`}><FormattedMessage id="components.signupForm.termsAgreed.error" /></div>
                                }
                            </div>
                        </Col>
                    </Row>

                    <Button className={`form-button`} disabled={this.state.isProcessing} variant="secondary" type="submit" block>
                        {this.state.isProcessing &&
                        <Spinner
                            as="span"
                            animation="border"
                            role="status"
                            aria-hidden="true"
                        />
                        }
                        <FormattedMessage id="components.signupForm.button.label" />
                    </Button>

                </Form>

                <Modal show={this.state.showModal} onHide={this.closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {this.state.fieldsError === true &&
                            <>
                                <FontAwesomeIcon size={`lg`} style={{marginRight: "15px"}} icon="exclamation-triangle" />
                                <FormattedMessage id="components.signupForm.alerts.titles.warning" />
                            </>
                            }
                            {this.state.serverError === true &&
                            <>
                                <FontAwesomeIcon size={`lg`} style={{marginRight: "15px"}} icon="exclamation-circle" />
                                <FormattedMessage id="components.signupForm.alerts.titles.error" />
                            </>
                            }
                            {this.state.finished === true &&
                            <>
                                <FontAwesomeIcon size={`lg`} style={{marginRight: "15px"}} icon="check-circle" />
                                <FormattedMessage id="components.signupForm.alerts.titles.success" />
                            </>
                            }
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className={`text-center m-3`}>
                            {this.state.fieldsError === true &&
                            <FormattedMessage id="components.signupForm.alerts.error" />
                            }
                            {this.state.serverError === true &&
                            <FormattedMessage id="components.signupForm.alerts.serverError" />
                            }
                            {this.state.finished === true &&
                            <FormattedMessage id="components.signupForm.alerts.success" />
                            }
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}

export default injectIntl(SignupForm);
